import classnames from "classnames";
import React from "react";

import { Props } from "../types";
import { getColor } from "../utils";
import styles from "./WarningTriangle.module.scss";

const WarningTriangle = ({ color, className }: Props) => {
  return (
    <div className={classnames(styles.wrapper, className)}>
      <i
        className={classnames(
          styles.triangle,
          styles.icon,
          getColor(styles, color!)
        )}
      />
      <span className={styles.exclamationMark}>!</span>
    </div>
  );
};

export { WarningTriangle };
